// @flow
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import {
  GeneralModalForm,
  LoadingProgress,
  NoItem,
  AppHeader
} from "imagus-components";
import CreateQuoteFormRedux from "./CreateQuoteFormRedux";
import UpgradeQuoteFormRedux from "./UpgradeQuoteFormRedux";
import QuoteList from "../../components/quotes/QuoteList";
import { buildQuoteItemJson } from "../../components/quotes/QuoteCompileFunctions";
import {
  fetchQuoteList,
  fetchPriceSheet,
  fetchCompanyList,
  fetchProductSheet
} from "../../actions/quoteActions";
import { propComparator } from "../../../global/functions/StringOperations";

import Button from "@material-ui/core/Button";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import UpdateIcon from "@material-ui/icons/Update";

type MyQuoteStateType = {
  quoteId: string,
  createModal: boolean,
  upgradeModel: boolean
};

class MyQuote extends Component<*, MyQuoteStateType> {
  constructor(props) {
    super(props);
    this.state = {
      quoteId: props.match.params.token ? props.match.params.token : "",
      createModal: false,
      upgradeModel: false
    };
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  componentDidMount() {
    if (!this.props.quotes) {
      this.props.actions.fetchQuoteList();
    }
    this.props.actions.fetchCompanyList();
    this.props.actions.fetchPriceSheet();
    this.props.actions.fetchProductSheet();
  }

  render(): * {
    const quotes = this.props.quotes;
    let quoteNode = null;
    if (quotes) {
      quotes
        .sort(propComparator("auditCreationDate", false, null, null, true))
        .reverse();
      if (quotes.length === 0) {
        quoteNode = <NoItem content="No Quote has created yet." />;
      } else {
        let quoteList = [];
        for (let i = 0; i < quotes.length; i++) {
          quoteList.push(buildQuoteItemJson(quotes[i]));
        }
        quoteNode = (
          <QuoteList
            quotes={quoteList}
            currentCompany={this.props.user && this.props.user.company}
            preLoadId={this.state.quoteId}
            canEdit
          />
        );
      }
    }
    if (!quoteNode) {
      return <LoadingProgress />;
    } else {
      return (
        <Fragment>
          <AppHeader
            title="My Quotes"
            actions={[
              <Button
                type="button"
                variant="contained"
                color="primary"
                className="dark-btn"
                onClick={(): Function =>
                  this.switchModalStatus("createModal")(true)
                }
              >
                <NoteAddIcon className="light-icon right-margin-5" />
                Create Quote
              </Button>,
              <Button
                type="button"
                variant="contained"
                color="primary"
                className="dark-btn left-margin-10"
                onClick={(): Function =>
                  this.switchModalStatus("upgradeModel")(true)
                }
              >
                <UpdateIcon className="light-icon right-margin-5" />
                Upgrade Licence
              </Button>
            ]}
          />
          <GeneralModalForm
            title="Create Quote"
            open={this.state.createModal}
            handleModalStatus={this.switchModalStatus("createModal")}
            fullScreen
            form={
              <CreateQuoteFormRedux
                companyType={
                  this.props.user &&
                  this.props.user.company &&
                  this.props.user.company.companyType
                }
                companyAuthority={
                  this.props.user &&
                  this.props.user.company &&
                  this.props.user.company.authorisedReseller === "TRUE"
                }
                onClose={(): * => this.switchModalStatus("createModal")(false)}
              />
            }
          />
          <GeneralModalForm
            title="Upgrade Licence Quote"
            open={this.state.upgradeModel}
            handleModalStatus={this.switchModalStatus("upgradeModel")}
            fullScreen
            form={
              <UpgradeQuoteFormRedux
                companyType={
                  this.props.user &&
                  this.props.user.company &&
                  this.props.user.company.companyType
                }
                onClose={(): * => this.switchModalStatus("upgradeModel")(false)}
              />
            }
          />
          <div className="app-panel">{quoteNode}</div>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  quotes: state.v3account.quote.quotes,
  user: state.v3account.user
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      fetchQuoteList,
      fetchPriceSheet,
      fetchCompanyList,
      fetchProductSheet
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(MyQuote);
